import { ISnackbarTimer } from './types';
import { Dispatch } from '../../../../../types/actions';
import { SNACKBAR_BUTTON_CANCEL, SNACKBAR_BUTTON_DELETE } from '../constants';
import { getDefaultActionEvent } from '../helpers/getDefaultActionEvent';
import { addUpdateSnackbarWithBubble } from '../addUpdateSnackbarWithBubble/addUpdateSnackbarWithBubble';
import { SnackbarVariant } from '../../store/types';

export const snackbarTimerDefault = (
    options: ISnackbarTimer
) => {
    return (dispatch: Dispatch) => {
        const shouldUseControlsDefault = options.buttons === undefined;
        if (shouldUseControlsDefault) {
            options.buttons = [
                {
                    onClick: () => {
                        dispatch(getDefaultActionEvent(options.id, options.actionCancel));
                    },
                    text: SNACKBAR_BUTTON_CANCEL
                },
                {
                    onClick: () => {
                        dispatch(getDefaultActionEvent(options.id, options.actionApply));
                    },
                    isPrimary: true,
                    isTimer: true,
                    text: SNACKBAR_BUTTON_DELETE
                },
            ];
        }
        dispatch(addUpdateSnackbarWithBubble({
            ...options,
            variant: SnackbarVariant.TIMER,
            onTimer: () => {
                dispatch(getDefaultActionEvent(options.id, options.actionApply));
            }
        }));
    }
};
